import { getPageAllowedRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { quickStartPageConfig } from "./quickStartPageConfig";
import {
  afterQuickStartSave,
  quickStartNewRecord,
  toQuickStartPayload,
} from "./quickStartRecord";

export const quickStartRecordDefinition: RecordDefinition = {
  path: "/quick-start",
  entityName: "quickstart",
  listRoute: "/settings",
  allowedRoles: getPageAllowedRoles("quick-start"),
  config: quickStartPageConfig,
  // Setup comes first: nothing to wander off to before it is done.
  hideNavigation: true,
  // Not an entity: a one-off setup that seeds the organisation, laid out here only.
  authorable: false,
  newRecord: quickStartNewRecord,
  saveMethod: "quick-start/initial-load",
  toSavePayload: toQuickStartPayload,
  afterSave: afterQuickStartSave,
  identity: {
    titleFields: [],
    fallbackTitle: "Quick Start",
    newRecordTitle: "Quick Start",
  },
};
